export default __webpack_public_path__ + "static/media/collapse_chevron.e91f4c6c.svg";